module.exports = __webpack_public_path__ + "static/media/60.555fc91d.png";